import angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import ngAnimate from 'angular-animate';
import 'ngSmoothScroll';

import './style/site.style.sass';

import CommonModule from 'common';
import ComponentModule from './component';
import SceneModule from './scene';

export default angular
    .module('presentation', [
        uiRouter,
        ngAnimate,
        'smoothScroll',

        CommonModule.name,
        ComponentModule.name,
        SceneModule.name
    ])
    .config(routerConfiguration);

/* @ngInject */
function routerConfiguration($locationProvider, $urlRouterProvider) {
    $locationProvider.html5Mode(true);
    
    // Ensure /start and /start/ redirect to /start/welcome before any other rules
    $urlRouterProvider.when('/start', '/start/welcome');
    $urlRouterProvider.when('/start/', '/start/welcome');
    
    // Default route
    $urlRouterProvider.otherwise('/');
}



// WEBPACK FOOTER //
// ./src/presentation/index.js